module.exports = __webpack_public_path__ + "static/assets/bb5983a5e6c9b655ecc5bd8633c4fc3b.png";